import { render, staticRenderFns } from "./vehicle-detail-information.vue?vue&type=template&id=2d5adca9&"
import script from "./vehicle-detail-information.vue?vue&type=script&lang=js&"
export * from "./vehicle-detail-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports